import { render, staticRenderFns } from "./PendingEnrollmentList.vue?vue&type=template&id=72577ec2&scoped=true&"
import script from "./PendingEnrollmentList.vue?vue&type=script&lang=js&"
export * from "./PendingEnrollmentList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pending-details.css?vue&type=style&index=0&lang=css&"
import style1 from "./PendingEnrollmentList.vue?vue&type=style&index=1&id=72577ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72577ec2",
  null
  
)

export default component.exports